/* eslint-disable max-len */
import { MasterQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import * as questionIds from "./wsasQuestionIds";

export const masterConfig: MasterQuestionConfig[] = [
    {
        id: questionIds.IaptWork,
        questionText: "WORK",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptHomeManagement,
        questionText: "HOME MANAGEMENT - Cleaning, tidying, shopping, cooking, looking after home/ children, paying bills etc.",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptSocialLeisureActivities,
        questionText: "SOCIAL LEISURE ACTIVITIES - With other people, e.g., Parties, pubs, outings, entertaining etc.",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptPrivateLeisureActivities,
        questionText: "PRIVATE LEISURE ACTIVITIES - Done alone, e.g., Reading, gardening, sewing, hobbies, walking etc.",
        canBeDisabled: false
    },
    {
        id: questionIds.IaptFamilyAndRelationships,
        questionText: "FAMILY AND RELATIONSHIPS - Form and maintain close relationships with others including the people that I live with",
        canBeDisabled: false
    }
];
/* eslint-enable max-len */
